// Single source of truth for what a form falls back to when the practice has
// no stored default (tri-state null). Consumed by CustomPrintFormPreviewProvider's
// default props, PurchaseAgreementDialog's explicit props, and the settings UI
// (EFFECTIVE_FORM_RENDERING_DEFAULTS), so the settings switches cannot drift
// from real form-open behavior.
//
// Caveats, both accepted as best-effort display:
// - provider_signature_in_footer applies only where the call site enables
//   provider signatures (providerSignatureEnabled); every current custom-form
//   call site does.
// - Enhanced Table Rendering is intentionally absent: it has no practice-wide
//   fallback — it follows each user's personal native_pdf_tables_enabled
//   setting until a practice default is explicitly saved.

export const CUSTOM_FORM_OPEN_DEFAULTS = {
  clinic_header: true,
  provider_signature_in_footer: true,
  patient_signature_in_footer: true
} as const;

export const PURCHASE_AGREEMENT_OPEN_DEFAULTS = {
  clinic_header: false,
  provider_signature_in_footer: false,
  patient_signature_in_footer: false
} as const;
